<template>
  <div ref='asideNav' class='asideBox'>
    <el-aside id="asideNav">
      <div class="logo-name">
        <p v-if="$store.getters.logoShow">EM</p>
        <!-- <p v-else>心理评测系统</p> -->
      </div>
      <!-- 左侧菜单栏 -->
      <el-menu
        :default-active="$route.path"
        class="el-menu-vertical"
        :collapse="$store.getters.isCollapse"
        background-color="rgb(40,49,66)"
        text-color="rgba(255,255,255,.7)"
        active-text-color="#ffffff"
        :unique-opened="$store.getters.uniquerouter"
        :collapse-transition="true"
        router
      >
        <!-- 一级菜单 -->
            <template v-for="(item, index) in menuList">

                    <el-menu-item class="menuHover" @click="noShow" v-if="item.MenuCode=='index' || item.Children.length == 0" :index="'/'+item.MenuCode" :key="index">
                        <i :class="item.Icon"></i>
                        <span slot="title" class="menuText">{{item.MenuName}}</span>
                    </el-menu-item>

                <el-submenu :index="index+''" v-else :key="index" class="menuHover">
                        <!-- <i :class="item.Icon"></i>
                        <span class="menuText">{{item.MenuName}}111</span> -->
                    <template slot="title">
                        <i :class="item.Icon"></i>
                        <span class="menuText">{{item.MenuName}}</span>
                    </template>
                    <!-- 二级菜单 -->
                    <el-menu-item
                        class="subMenu"
                        :index="'/'+subItem.MenuCode"
                        v-for="(subItem, index2) in item.Children"
                        :key="index2"
                         @click="noShow"
                    >
                        <template>
                        <i :class="subItem.Icon"></i>
                        <span>{{subItem.MenuName}}</span>
                        </template>
                    </el-menu-item>
                </el-submenu>
            </template>



      </el-menu>
    </el-aside>
  </div>
</template>

<script>
import menuTree from "./menuTree";
import { closeSync } from "fs";
import { Axios, AsyncAxios } from "@/common/request";
export default {
  name: "asideNav",
  components: {
    menuTree
  },
  data() {
    return {
      menuList: []
      // iconList:['el-icon-setting' ,'el-icon-first-aid-kit','fa fa-telegram','el-icon-s-marketing',
      // 'fa fa-dashboard','fa fa-universal-access','fa fa-heartbeat'],
      // subIconList:[
      //   ['el-icon-menu','fa fa-users','el-icon-s-custom','fa fa-sitemap'],
      //   ["fa fa-user-md", "fa fa-user-circle",'fa fa-calendar-plus-o','fa fa-plus-square'],    
      //   ['fa fa-sliders'],
      //   ['el-icon-user-solid','fa fa-address-card','el-icon-s-order'],
      //   ['fa fa-dashboard','fa fa-bed'],
      //   ['fa fa-binoculars','fa fa-tasks'],
      //   ['el-icon-edit-outline','el-icon-help']
      // ]
    };
  },
  watch: {
    // 监听浏览器直接输入路由，将此路由添加到tabnavBox
    "$route.path": function(val) {
      this.selectmenu(val);
    }
  },
  mounted() {
    this.menuList = JSON.parse(window.sessionStorage.getItem("Menus"));
    this.getMenuList();
    this.setShow();
  },
  methods: {
    // 获取菜单列表
    getMenuList(){
      // Axios("Sys/GetRoleMenuListByRoleID", "post", {}, this).then(ret => {
      //   console.log(ret);
       
      // })
    },
    selectmenu(key) {
      let router = this.$store.getters.routers;
      let name = "";
      let navTitle = function(path, routerARR) {
        for (let i = 0; i < routerARR.length; i++) {
          if (routerARR[i].children.length > 0 || routerARR[i].path === path) {
            if (
              routerARR[i].path === path &&
              routerARR[i].children.length < 1
            ) {
              name = routerARR[i].name;
              console.log(name);
              break;
            }
            navTitle(path, routerARR[i].children);
          }
        }
        return name;
      };
      this.$store.dispatch("addTab", {
        title: navTitle(key, router),
        path: key
      });
    },
    setShow(){

        // this.$refs.asideNav.$el.style.display = 'none';
        // console.log(this.$refs.asideNav.$el.style.display);
        // console.log(this.$store.state);
    },
    noShow(){
        // console.log(this.$store);
        this.$store.state.menuIsShow = false;
    }
  },
    
watch: {
    '$store.state.menuIsShow': function () {
        if(!this.$store.state.menuIsShow){
            this.$refs.asideNav.setAttribute('style','transform:translateX(-100%)');
            this.$refs.asideNav.setAttribute('style','-ms-transform:translateX(-100%)');
            this.$refs.asideNav.setAttribute('style','-webkit-transform:translateX(-100%)');
        }else{
            this.$refs.asideNav.setAttribute('style','transform:translateX(0)');
            this.$refs.asideNav.setAttribute('style','-ms-transform:translateX(0)');
            this.$refs.asideNav.setAttribute('style','-webkit-transform:translateX(0)');
        }
        
        // this.$refs.asideNav.style('transform','scale(0,1)');
        // if(this.$refs.asideNav.$el.style.display == '' ||this.$refs.asideNav.$el.style.display == 'block'){
        //     this.$refs.asideNav.$el.style.transform = 'scale(0,1)'
        //     // this.$refs.asideNav.$el.style.display = 'none';
        // }else{
        //     this.$refs.asideNav.$el.style.display = 'block';
        // }
      //你需要执行的代码
    }
  },
};
</script>

<style lang="scss">
$top: top;
$bottom: bottom;
$left: left;
$right: right;
%w100 {
  width: 100%;
}


.asideBox{
    position:fixed;
    z-index:9999;
    transition:.5s;
    transform-origin:0 0 0;
    height:calc(100vh - 60px);
    box-shadow:2px 20px 20px 10px rgba(168, 168, 168, 0.2) !important;
    -webkit-box-shadow:2px 20px 20px 10px rgba(168, 168, 168, 0.5) !important;
    transform:translateX(-100%)
}

%h100 {
  height: 100%;
}

%cursor {
  cursor: pointer;
}

@mixin set-value($side, $value) {
  @each $prop in $leftright {
    #{$side}-#{$prop}: $value;
  }
}
.home {
    // 主页tag样式
  width:100%;
  padding-left:20px;
  color: rgb(255, 255, 255);
//   background-color: #2949e4 !important;
background-color: #121212 !important;
  height: 56px;
  line-height: 56px;
  font-size:17px;
  i{
    margin-right:5px
  }

}
#asideNav {
  width: auto !important;
  display: flex;
  flex-direction: column;
  border-right: solid 1px #e6e6e6;
  background-color: rgb(40,49,66);
  .logo-name {
      margin-top: 10px;
    background-color: #121212 !important;
    @extend %w100;
    font-weight: 300;
    z-index: 999;
    p {
      height: 50px;
      line-height: 50px;
      text-align: center;
      font-size: 18px;
      color: #5e6d82;
    }
  }
  .menuText{
        font-size:17px !important;
    }
  .el-menu-vertical:not(.el-menu--collapse) {
    width: 220px;
    @extend %h100;
    overflow-y: scroll;
  }
  .el-menu {
    flex: 1;
    overflow: inherit;
    border-right: none;
    &::-webkit-scrollbar {
      display: none;
    }
    .fa {
      vertical-align: middle;
      margin-right: 5px;
      width: 24px;
      text-align: center;
      font-size: 18px;
    }
    // tag样式
    .el-menu-item {
      background-color: #1d1b1b;
      font-size:15px;
      &:hover {
        color: #ffffff !important;
        background-color: rgba(133, 133, 133, 0.2) !important;
      }
    }
    // 选中tag样式
    .el-menu-item.is-active {
    //   background-color: #2949e4 !important;
    border-left:6px solid #409EFF;
    color: #ffffff !important;
    background-color: rgba(133, 133, 133, 0.2) !important;
    }
    .is-opened > .el-submenu__title > .el-icon-arrow-down {
      color: #ffffff;
      font-weight: 500;
      font-size: 18px;
    }
    // 二级菜单背景
    .subMenu{
        background-color: rgb(32, 42, 52) !important;
    }

    .menuHover{
        .el-submenu__title:hover{
            color: #ffffff !important;
            background-color: rgba(133, 133, 133, 0.2) !important;
        }
        
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/aside/aside.vue